<template>
  <main class="main-content main-content-bg">
    <section class="login-wrap">
      <div class="container mb-5">
        <div class="row justify-content-center">
          <div class="col-xl-4 col-lg-5 col-md-6">

            <!-- Card -->
            <div class="card shadow-sm border-1">
              <div class="card-body p-4 p-md-4">
                
                <div class="px-5 pt-4 pb-3">
                  <img src="@/assets/img/icons/logo.svg" class="img-fluid d-block mx-auto" style="max-height:48px;" alt="로고">
                </div>

                <p class="text-muted text-center mb-5">회원정보를 입력해주세요</p>

                <form class="text-start" @submit.prevent="handleLogin">
                  <!-- 아이디 -->
                  <div class="mb-3">
                    <label for="email" class="form-label mb-1">아이디</label>
                    <input
                      id="email"
                      type="text"
                      class="form-control"
                      placeholder="아이디"
                      v-model="loginForm.id"
                      autocomplete="username"
                    />
                  </div>

                  <!-- 비밀번호 -->
                  <div class="mb-2">
                    <div class="d-flex justify-content-between">
                      <label for="password" class="form-label mb-1">비밀번호</label>
                    </div>
                    <div class="position-relative">
                      <input
                        id="password"
                        type="password"
                        class="form-control"
                        placeholder="비밀번호"
                        v-model="loginForm.password"
                        autocomplete="current-password"
                      />
                    </div>
                  </div>

                  <!-- remember me -->
                  <div class="my-3">
                    <soft-switch id="rememberMe" name="rememberMe" v-model="rememberMe"> 아이디 저장 </soft-switch>
                  </div>

                  <!-- 로그인 버튼 -->
                  <div class="d-grid mt-5">
                    <button class="btn btn-success fs-6" type="submit">로그인</button>
                  </div>
                </form>
              </div>

              <div class="card-footer bg-transparent text-center py-3">
                <p class="mb-0 text-muted text-sm mb-4">
                  계정생성은 관리자에게 문의바랍니다.
                </p>
              </div>
            </div>
            <!-- /Card -->
          </div>
        </div>
      </div>
    </section>

    <app-footer />
  </main>
</template>

<script>
import SoftSwitch from "@/components/SoftSwitch.vue";
import AppFooter from "@/examples/Footer.vue";
import api from "@/api/api";
import { mapMutations, mapActions } from "vuex";

const body = document.getElementsByTagName("body")[0];

export default {
  name: "SignIn",
  components: { AppFooter, SoftSwitch },
  data() {
    return {
      loginForm: { id: "", password: "" },
      rememberMe: false,
    };
  },
  inject: ["showLoading", "hideLoading"],
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
    ...mapActions("UserStore", ["loginSuccess"]),
    async handleLogin() {
      if (!this.loginForm.id) return this.toastError("아이디를 입력해주세요.");
      if (!this.loginForm.password) return this.toastError("비밀번호를 입력해주세요.");

      this.showLoading("로그인중...");
      try {
        const delay = (ms) => new Promise((r) => setTimeout(r, ms));
        const [res] = await Promise.all([
          api.post("/auth/login-jwt", this.loginForm),
          delay(1000),
        ]);

        const data = res.data;
        if (data.resultCode !== "200") {
          return this.toastError("로그인 실패: " + (data.resultMessage || "다시 시도해주세요."));
        }

        const token = data.jToken;
        if (!token) return this.toastError("토큰이 없습니다. 관리자에게 문의하세요.");

        const userInfo = data.resultVO || {};
        const mfInfo = data.mfInfo;

        await this.$store.dispatch("UserStore/loginSuccess", { userInfo, token, mfInfo });

        if (this.rememberMe) localStorage.setItem("savedId", this.loginForm.id);
        else localStorage.removeItem("savedId");

        this.toastSuccess("로그인 되었습니다.");
        this.$router.replace("/dashboard");

      } catch (e) {
        console.error(e);
        this.toastError("서버 오류 또는 로그인 실패");
      } finally {
        this.hideLoading();
      }
    },
  },
  mounted() {
  },
  created() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    body.classList.remove("bg-gray-100");

    const savedId = localStorage.getItem("savedId");
    if (savedId) {
      this.loginForm.id = savedId;
      this.rememberMe = true;
    }
  },
  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    body.classList.add("bg-gray-100");
  },
};
</script>

<style scoped>
/* 전체 레이아웃을 화면 중앙에 */
.login-wrap {
  min-height: 90vh;
  display: grid;
  place-items: center;
}
</style>
